// src/components/discussion/CommentFiles.jsx
import { useMemo } from "react";
import { Ic } from "../Icons";
import { ICONS } from "../iconsData";
import { formatSize } from "../../utils/format";
import { fmtDMY } from "../../utils/date";

/**
 * Режим «Файлы» в обсуждении. Отдельно рендерятся изображения
 * (миниатюра + Lightbox) и прочие вложения (иконка + скачать).
 * Данные готовит родитель (items), модуль не читает стор.
 */
export default function CommentFiles({ items, getAuthor, openLightbox }) {
  const imageItems = useMemo(
    () =>
      items.filter(({ attachment }) => attachment.mime.startsWith("image/")),
    [items],
  );
  const photoList = useMemo(
    () => imageItems.map(({ attachment }) => attachment),
    [imageItems],
  );

  const handleDownloadZip = () => {
    const ids = items.map(({ attachment }) => attachment.id).join(",");
    window.location.href = `/api/v1/files/download-zip?ids=${ids}`;
  };

  if (items.length === 0) {
    return <div className="empty-note">В обсуждении пока нет файлов</div>;
  }

  return (
    <div className="file-all-list-wrapper">
      {items.length > 1 && (
        <div className="flex justify-end mb-3">
          <button className="btn ghost sm" onClick={handleDownloadZip}>
            <Ic d={ICONS.download} size={14} /> Скачать всё архивом (
            {items.length})
          </button>
        </div>
      )}

      <div className="file-all-list">
        {items.map(({ comment, attachment }) => {
          const author = getAuthor(comment.authorId);
          const authorLabel = author ? `${author.last} ${author.first}` : "-";
          const isImage = attachment.mime.startsWith("image/");
          const meta = `${formatSize(attachment.size)} · загрузил ${authorLabel} · ${
            attachment.uploadedAt ? fmtDMY(attachment.uploadedAt) : "-"
          }`;

          if (isImage) {
            const idx = imageItems.findIndex(
              ({ attachment: a }) => a.id === attachment.id,
            );
            return (
              <div className="file-item" key={attachment.id}>
                <div
                  className="attachment-item"
                  onClick={() => openLightbox(photoList, idx)}
                >
                  <img
                    src={attachment.url}
                    alt={attachment.name}
                    className="attachment-thumb"
                  />
                  <div className="attachment-overlay">
                    <a
                      className="attachment-download"
                      href={attachment.url}
                      download={attachment.name}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <Ic d={ICONS.download} size={16} />
                    </a>
                  </div>
                </div>
                <div className="file-info">
                  <div className="file-name">{attachment.name}</div>
                  <div className="file-meta">{meta}</div>
                </div>
                <a
                  className="btn ghost sm"
                  href={attachment.url}
                  download={attachment.name}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Скачать
                </a>
              </div>
            );
          }

          // Для всех НЕ-картинок (Excel, Word, PDF и т.д.)
          return (
            <div className="file-item" key={attachment.id}>
              <Ic d={ICONS.file} size={24} />
              <div className="file-info">
                <div className="file-name">{attachment.name}</div>
                <div className="file-meta">{meta}</div>
              </div>
              <a
                className="btn ghost sm"
                href={attachment.url}
                download={attachment.name}
                target="_blank"
                rel="noopener noreferrer"
              >
                Скачать
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
}
